/** Default page size for catalog search results. */
export const CATALOG_PAGE_SIZE = 50;

/** Debounce delay for catalog search input in milliseconds. */
export const CATALOG_SEARCH_DEBOUNCE_MS = 300;
